import { StateAbbreviation } from '@/constants/states';

export const stateData: Record<
	StateAbbreviation,
	{ costPerKwh: string; coolingHours: string }
> = {
	AL: { costPerKwh: '0.15166', coolingHours: '1500' },
	AK: { costPerKwh: '0.24256', coolingHours: '300' },
	AZ: { costPerKwh: '0.14852', coolingHours: '1500' },
	AR: { costPerKwh: '0.12176', coolingHours: '1500' },
	CA: { costPerKwh: '0.32352', coolingHours: '900' },
	CO: { costPerKwh: '0.14576', coolingHours: '900' },
	CT: { costPerKwh: '0.28476', coolingHours: '900' },
	DE: { costPerKwh: '0.16682', coolingHours: '900' },
	DC: { costPerKwh: '0.17438', coolingHours: '1500' },
	FL: { costPerKwh: '0.14608', coolingHours: '1500' },
	GA: { costPerKwh: '0.13576', coolingHours: '1500' },
	HI: { costPerKwh: '0.44558', coolingHours: '2550' },
	ID: { costPerKwh: '0.11224', coolingHours: '600' },
	IL: { costPerKwh: '0.16028', coolingHours: '900' },
	IN: { costPerKwh: '0.14598', coolingHours: '900' },
	IA: { costPerKwh: '0.12836', coolingHours: '900' },
	KS: { costPerKwh: '0.13908', coolingHours: '1500' },
	KY: { costPerKwh: '0.1274', coolingHours: '900' },
	LA: { costPerKwh: '0.11604', coolingHours: '1500' },
	ME: { costPerKwh: '0.22808', coolingHours: '300' },
	MD: { costPerKwh: '0.1773', coolingHours: '900' },
	MA: { costPerKwh: '0.2909', coolingHours: '900' },
	MI: { costPerKwh: '0.18856', coolingHours: '600' },
	MN: { costPerKwh: '0.14772', coolingHours: '600' },
	MS: { costPerKwh: '0.1373', coolingHours: '1500' },
	MO: { costPerKwh: '0.1199', coolingHours: '1500' },
	MT: { costPerKwh: '0.12388', coolingHours: '600' },
	NE: { costPerKwh: '0.1125', coolingHours: '900' },
	NV: { costPerKwh: '0.16532', coolingHours: '900' },
	NH: { costPerKwh: '0.23454', coolingHours: '300' },
	NJ: { costPerKwh: '0.18132', coolingHours: '900' },
	NM: { costPerKwh: '0.14104', coolingHours: '1500' },
	NY: { costPerKwh: '0.23576', coolingHours: '900' },
	NC: { costPerKwh: '0.14586', coolingHours: '1500' },
	ND: { costPerKwh: '0.11038', coolingHours: '600' },
	OH: { costPerKwh: '0.16206', coolingHours: '900' },
	OK: { costPerKwh: '0.1169', coolingHours: '1500' },
	OR: { costPerKwh: '0.14404', coolingHours: '600' },
	PA: { costPerKwh: '0.17612', coolingHours: '900' },
	RI: { costPerKwh: '0.29694', coolingHours: '900' },
	SC: { costPerKwh: '0.1432', coolingHours: '1500' },
	SD: { costPerKwh: '0.1235', coolingHours: '600' },
	TN: { costPerKwh: '0.12484', coolingHours: '1500' },
	TX: { costPerKwh: '0.14648', coolingHours: '1500' },
	UT: { costPerKwh: '0.10984', coolingHours: '900' },
	VT: { costPerKwh: '0.21614', coolingHours: '300' },
	VA: { costPerKwh: '0.1444', coolingHours: '900' },
	WA: { costPerKwh: '0.11642', coolingHours: '600' },
	WV: { costPerKwh: '0.14894', coolingHours: '900' },
	WI: { costPerKwh: '0.17096', coolingHours: '600' },
	WY: { costPerKwh: '0.11804', coolingHours: '600' },
} as const;
